var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export var VideoOff = function VideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.177 2.468c-.368-.5-1.055-.618-1.534-.265-.479.353-.568 1.045-.2 1.544l1.036 1.406A2 2 0 002 7.084v9.528a2 2 0 002 2h9.403l1.495 2.027c.369.5 1.056.619 1.535.266.479-.354.568-1.045.2-1.545l-.997-1.352.003-.003-9.527-12.92h-.006L4.177 2.467zM8.504 5.084l7.7 10.443v-1.752l3.108 3.334c.924.99 2.583.346 2.597-1.008L22 7.474c.015-1.318-1.557-2.012-2.522-1.112l-3.273 3.052V7.084a2 2 0 00-2-2h-5.7z",
    fill: "currentColor"
  })));
};